export const LOOKUP_LOCALE_ZHCHT = {
    placeholder: 'è«é¸æ',
    favorites: 'æ¶èå¤¾',
    selected: 'å·²é¸æ¸æ',
    okText: 'ç¢ºå®',
    cancelText: 'åæ¶',
    allColumns: 'ææå',
    datalist: 'æ¸æåé¶',
    mustWriteSomething: 'è«è¼¸å¥ééµå­å¾æ¥è©¢ã',
    mustChoosAdatarow: 'è«é¸æä¸æ¢è¨éï¼',
    tipText: 'æ¨è¦æ¾çæ¯ä¸æ¯éäºï¼',
    cascade: {
        enable: 'åæ­¥é¸æ',
        disable: 'åé¸æèªèº«',
        up: 'åå«ä¸ç´',
        down: 'åå«ä¸ç´'
    },
    favoriteInfo: {
        addFav: 'æ¶èæåã',
        cancelFav: 'åæ¶æ¶èæåã '
    },
    getAllChilds: 'ç²åææå­ç´æ¸æ',
    contextMenu: {
        expandall: 'å¨é¨å±é',
        collapseall: 'å¨é¨æ¶èµ·',
        expandByLayer: 'æå±¤ç´å±é',
        expand1: 'å±é 1 ç´',
        expand2: 'å±é 2 ç´',
        expand3: 'å±é 3 ç´',
        expand4: 'å±é 4 ç´',
        expand5: 'å±é 5 ç´',
        expand6: 'å±é 6 ç´',
        expand7: 'å±é 7 ç´',
        expand8: 'å±é 8 ç´',
        expand9: 'å±é 9 ç´'
    },
    quick: {
        notfind: 'æªæ¾å°æç´¢å§å®¹',
        more: 'é¡¯ç¤ºæ´å¤'
    },
    configError: 'å¹«å©é¡¯ç¤ºåæªéç½®ï¼è«æª¢æ¥æ¯å¦å·²æ­£ç¢ºéç½®å¹«å©æ¸ææº!',
    selectedInfo: {
        total: 'å·²é¸ <span class="selected-counter mx-1">{0}</span> æ¢',
        clear: 'åæ¶å·²é¸',
        remove: 'ç§»é¤ ({0})',
        confirm: 'æ¨ç¢ºèªè¦åæ¶ææé¸ä¸­è¨éå?'
    },
    clearAllConditions: 'æ¸é¤æææ¥è©¢æ¢ä»¶',
    anyFields: 'å¨é¨'
};
